import React, { useEffect } from 'react'
import { isCoreEmbedMessage } from 'Data/isCoreEmbedMessage.js'
import { useDataChange } from 'Simple/Data.js'

import View from './view.js'

export default function Logic(props) {
  let change = useDataChange({
    context: 'tab',
    path: 'coreMessage',
    viewPath: props.viewPath,
  })

  useEffect(() => {
    window.addEventListener('message', listener, false)

    return () => {
      window.removeEventListener('message', listener)
    }

    async function listener(event) {
      if (
        !isCoreEmbedMessage(event) ||
        event.data.type !== 'navigation' ||
        event.data.section !== 'financial'
      ) {
        return
      }

      change({
        ...event.data.params,
        section: event.data.section,
      })
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return <View {...props} />
}
